import { component, html, Task, VNode } from "cr-26";
import counterPage from "./pages/counterPage";
import listPage from "./pages/listPage";
import clock from "./components/clock";
const { div } = html;

export type RootState = Readonly<{
  theme: Theme;
  page?: Page;
  likes: {
    counterPage: number;
    listPage: number;
  };
}>;

export type RootActionPayloads = Readonly<{
  SetPage: { page: Page };
  SetTheme: { theme: Theme };
  Like: { page: Page };
}>;

export type RootTaskPayloads = Readonly<{
  SetDocTitle: { title: string };
}>;

export type Page = "counterPage" | "listPage";

export type Theme = "light" | "dark";

export type Component = {
  State: RootState;
  ActionPayloads: RootActionPayloads;
  TaskPayloads: RootTaskPayloads;
};

export default component<Component>(() => ({
  state: (): RootState => ({
    theme: "dark",
    page: undefined,
    likes: {
      counterPage: 0,
      listPage: 0
    }
  }),

  actions: {
    SetPage: ({ page }, { state }): { state: RootState } => {
      return {
        state:
          page === state.page
            ? state
            : {
                ...state,
                page
              }
      };
    },
    SetTheme: ({ theme }, { state }): { state: RootState } => {
      return {
        state:
          theme === state.theme
            ? state
            : {
                ...state,
                theme
              }
      };
    },
    Like: ({ page }, { state }): { state: RootState } => {
      return {
        state: {
          ...state,
          likes: {
            ...state.likes,
            [page]: state.likes[page] + 1
          }
        }
      };
    }
  },

  tasks: {
    // Demonstrates a task that is only an effect
    SetDocTitle: ({ title }): Task<void, unknown, RootState> => ({
      perform: (): void => {
        document.title = title;
      }
    })
  },

  view({ id, state }): VNode {
    return div(
      `#${id}.page`,
      { class: { light: state.theme === "light", dark: state.theme === "dark" } },
      [
        ((): VNode | undefined => {
          switch (state.page) {
            case "listPage":
              return listPage("#list-page");

            case "counterPage":
              return counterPage("#counter-page");
          }
        })(),
        clock("#clock")
      ]
    );
  }
}));
